
import { connect } from 'react-redux'
import { compose, branch, renderComponent, renderNothing, lifecycle } from 'recompose'
import NewReceivable from './NewReceivable'

const Component = compose(

  connect(state => {
    return {
      items: state.breadcrumb
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.dispatch({
        type: 'SET_BREADCRUMB',
        items: [
          { page: 'Home', url: '/' },
          { page: 'Contas a Receber', url: '/receivables' },
          { page: 'Incluir', url: '#' },
        ]
      })
    }
  }),
  branch(
    () => {
      return true
    },
    renderComponent(NewReceivable),
    renderNothing
  )
)(NewReceivable)

export default Component